import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

const icons = [
  {
    name: 'panel-collapsed',
    path: 'assets/autopilot/panel-collapsed.svg'
  },
  {
    name: 'panel-expanded',
    path: 'assets/autopilot/panel-expanded.svg'
  },
  {
    name: 'ai-collapsed',
    path: 'assets/journeys/ai-collapsed.svg'
  },
  {
    name: 'ai-expanded',
    path: 'assets/journeys/ai-expanded.svg'
  },
  {
    name: 'ai-star',
    path: 'assets/ai-star.svg'
  },
  {
    name: 'support',
    path: 'assets/icons/support.svg'
  }
];

export const matIconsRegistry = (matIconRegistry: MatIconRegistry, domSanitizer: DomSanitizer) => {
  icons.forEach(icon => {
    matIconRegistry.addSvgIcon(icon.name, domSanitizer.bypassSecurityTrustResourceUrl(icon.path));
  });
};
